import ParcelaAntecipacaoSienge from "../sienge/antecipacaoParcela/ParcelaAntecipacaoSienge";

export default class SimularAntecipacaoRequest {
    newDueDate: Date;
    installments: ParcelaAntecipacaoSienge[]

    constructor(newDueDate: Date, installments: ParcelaAntecipacaoSienge[]) {
        this.newDueDate = newDueDate;
        this.installments = installments;
    }
}